// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5Udvt","double":"styles_double__puIWo","limited":"styles_limited__TseZ6"};